// Typed client for the /calls/* REST API (LT-253 / LT-255). Matches the
// contactsAPI / accountsAPI convention.

import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;
if (!API_BASE_URL) {
  throw new Error('REACT_APP_API_URL environment variable is required');
}

const client = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers = config.headers ?? {};
    (config.headers as Record<string, string>).Authorization = `Bearer ${token}`;
  }
  return config;
});

export interface CallSummaryListItem {
  id: string;
  timestamp: string;
  call_direction?: 'inbound' | 'outbound' | string | null;
  call_ended_reason?: string | null;
  call_cost?: number | null;
  disposition?: string | null;
  lead_temperature?: string | null;
  follow_up_status?: string | null;
  analysis_summary?: string | null;
  contact_id?: string | null;
  contact_first_name?: string | null;
  contact_last_name?: string | null;
  contact_phone?: string | null;
}

export interface CallSummaryListResponse {
  calls: CallSummaryListItem[];
  total: number;
  skip: number;
  limit: number;
}

export interface CallListFilters {
  skip?: number;
  limit?: number;
  contact_id?: string;
  direction?: 'inbound' | 'outbound';
  disposition?: string;
  start_date?: string; // ISO
  end_date?: string; // ISO
}

function buildParams(filters?: CallListFilters): Record<string, string | number> {
  const out: Record<string, string | number> = {};
  if (!filters) return out;
  if (typeof filters.skip === 'number') out.skip = filters.skip;
  if (typeof filters.limit === 'number') out.limit = filters.limit;
  if (filters.contact_id) out.contact_id = filters.contact_id;
  if (filters.direction) out.direction = filters.direction;
  if (filters.disposition) out.disposition = filters.disposition;
  if (filters.start_date) out.start_date = filters.start_date;
  if (filters.end_date) out.end_date = filters.end_date;
  return out;
}

export const callsAPIv2 = {
  list: async (filters?: CallListFilters): Promise<CallSummaryListResponse> => {
    const r = await client.get<CallSummaryListResponse>('/calls/', {
      params: buildParams(filters),
    });
    return r.data;
  },
};
